export const demoOverview = {
  metrics: {
    clicks: { value: 2847, change: 12.4 },
    impressions: { value: 128420, change: 8.7 },
    ctr: { value: 0.0222, change: 3.2 },
    position: { value: 18.6, change: 1.8 }
  },
  ranks: {
    average_rank: 16.8,
    top3: 84,
    top10: 261,
    top30: 647,
    top100: 1032,
    not_found: 206
  },
  daily: Array.from({ length: 28 }, (_, index) => {
    const wave = Math.sin(index / 2.8) * 18;
    return {
      date: new Date(Date.UTC(2026, 6, index)).toISOString().slice(0, 10),
      clicks: Math.round(82 + index * 1.6 + wave),
      impressions: Math.round(3800 + index * 46 + wave * 22),
      ctr: 0.019 + index * 0.00012,
      position: 21.4 - index * 0.1
    };
  })
};

const keywords = [
  ["facebook ads agency", "Keyword US Services", "USA", "services", 3, 2, 486, 6420],
  ["facebook marketing for aviation", "Keyword US Blog", "USA", "blog", 3, 1, 164, 3290],
  ["meta ads agency uk", "Keyword UK Services", "GBR", "services", 6, 4, 131, 2480],
  ["facebook ads for saas", "Keyword US Blog", "USA", "blog", 8, -2, 108, 1920],
  ["performance marketing agency", "Keyword India Services", "IND", "services", 11, 6, 87, 2810],
  ["facebook ads audit", "Keyword UK Blog", "GBR", "blog", 14, 3, 52, 1760],
  ["meta advertising agency", "Keyword Ukraine Services", "UKR", "services", 19, -4, 34, 930],
  ["facebook ads for ecommerce", "Keyword India Blog", "IND", "blog", 22, 8, 29, 1440],
  ["paid social agency", "Keyword Russia Services", "RUS", "services", 27, 2, 18, 620],
  ["facebook marketing strategy", "Keyword US Blog", "USA", "blog", 31, -7, 14, 1080]
] as const;

export const demoRankings = keywords.map(
  ([keyword, project, country, category, position, change, clicks, impressions], index) => ({
    source_keyword_id: 95_482_716 + index,
    keyword_original: keyword,
    keyword_normalized: keyword,
    project_name: project,
    source_project_id: 5_109_274 + index,
    country,
    category,
    rank_date: "2026-07-25",
    position,
    rank_change: change,
    is_found: 1,
    found_url: `https://agrowth.io/${category === "blog" ? "blogs/knowledge" : "services"}/${keyword.replaceAll(" ", "-")}`,
    clicks,
    impressions,
    ctr: clicks / impressions,
    gsc_position: position + 2.4,
    rank_position: position
  })
);

export const demoTraffic = {
  rows: demoRankings.map((row) => ({
    query_original: row.keyword_original,
    query_normalized: row.keyword_normalized,
    country: row.country,
    clicks: row.clicks,
    impressions: row.impressions,
    ctr: row.ctr,
    position: row.gsc_position
  })),
  daily: demoOverview.daily
};

export const demoMovers = {
  ranking: {
    winners: demoRankings
      .filter((row) => row.rank_change > 0)
      .sort((a, b) => b.rank_change - a.rank_change)
      .map((row) => ({ ...row, change: row.rank_change })),
    losers: demoRankings
      .filter((row) => row.rank_change < 0)
      .sort((a, b) => a.rank_change - b.rank_change)
      .map((row) => ({ ...row, change: row.rank_change }))
  },
  traffic: {
    winners: demoRankings.slice(0, 5).map((row, index) => ({
      query_original: row.keyword_original,
      country: row.country,
      clicks_current: row.clicks,
      clicks_previous: Math.round(row.clicks * (0.62 + index * 0.04)),
      click_change: Math.round(row.clicks * (0.38 - index * 0.04))
    })),
    losers: demoRankings.slice(5).map((row, index) => ({
      query_original: row.keyword_original,
      country: row.country,
      clicks_current: row.clicks,
      clicks_previous: row.clicks + 18 + index * 6,
      click_change: -(18 + index * 6)
    }))
  }
};

export const demoSync = {
  runs: [
    {
      id: "sync-demo-1",
      source: "all",
      trigger_type: "cron",
      status: "success",
      tasks_total: 184,
      tasks_completed: 184,
      rows_upserted: 4268,
      errors_count: 0,
      started_at: "2026-07-27 23:00:02",
      completed_at: "2026-07-27 23:04:36"
    },
    {
      id: "sync-demo-2",
      source: "all",
      trigger_type: "cron",
      status: "success",
      tasks_total: 176,
      tasks_completed: 176,
      rows_upserted: 3984,
      errors_count: 0,
      started_at: "2026-07-26 23:00:01",
      completed_at: "2026-07-26 23:03:58"
    }
  ],
  latestTasks: [
    { task_type: "serprobot-keyword", status: "success", count: 141 },
    { task_type: "gsc-country-day", status: "success", count: 35 },
    { task_type: "gsc-site-day", status: "success", count: 7 },
    { task_type: "gsc-discover", status: "success", count: 1 }
  ],
  failedTasks: [],
  sourceData: {
    serprobot_latest_date: "2026-07-27",
    gsc_latest_date: "2026-07-25",
    gsc_page_latest_date: "2026-07-25",
    ga4_latest_date: "2026-07-25",
    ga4Configured: true
  }
};
